import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useAuth } from '../../context/Auth';

import { Button, Card } from '../../components/UI';

import { AccountNav } from './AccountNav';
import { SecondaryProfile } from './SecondaryProfile';
import { AccountCredentials } from './AccountCredentials';
import { Account2FA } from './Account2FA';
import { AccountMainProfile } from './AccountMainProfile';
import { UpgradeSubscription } from '../../components/UpgradeSubscription/UpgradeSubscription';

const Account = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <div
      className={
        'flex flex-col w-full bg-white text-black items-center dark:bg-black-real'
      }
    >
      <div className={'w-full lg:w-8/12X'}>
        <AccountNav />
        <AccountMainProfile />
        <AccountCredentials />
        <Account2FA />
        <>
          {user &&
            user.profiles.items
              .filter((p) => !p.default)
              .map((profile: any, index: number) => {
                return (
                  <SecondaryProfile
                    key={'profile' + index}
                    profile={profile}
                    index={index}
                  />
                );
              })}
        </>
        {user?.membership?.membershipPlan?.features?.profiles &&
        user?.membership?.membershipPlan?.features?.profiles > 1 ? (
          <Card
            className="bg-primary my-4"
            title={t('account.addProfile.title')}
          >
            <div className="flex justify-start align-center">
              <div className="flex flex-col gap-5 w-full">
                <div className="flex flex-col justify-between align-center">
                  <p>{t('account.addProfile.description')}</p>
                </div>
                <div className="flex justify-end">
                  <Button
                    type="button"
                    variant="tertiary"
                    onClick={() => navigate('/choose-username?newAccount=true')}
                  >
                    Create account
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        ) : (
          <UpgradeSubscription
            viewMode={'card'}
            feature="PROFILES"
            textVars={{
              number: user?.membership?.membershipPlan?.features?.profiles,
            }}
          />
        )}
      </div>
    </div>
  );
};

export { Account };
